const RISKS = ['Problem', 'Risk', 'Opportunity'];
const USE_CASE = ['Use case'];
const JOURNEY = ['Customer journey'];
const STAKEHOLDER = ['Stakeholder'];

/**
 * Поля записів бізнес-аналізу, що стосуються лише окремих видів (таблиця прототипу v4 BA_TF): поле → види. Поля поза таблицею стосуються
 * всіх видів. Доки метадані не описують видимість полів за видом, таблиця живе тут, поруч із розділами «Проєктування».
 */
const KIND_FIELDS: Readonly<Record<string, readonly string[]>> = {
  stakeholder: ['Stakeholder need', 'Customer journey', 'Use case', 'Requirement'], moscow: ['Feature', 'Use case', 'Requirement'], reqType: ['Requirement'],
  impact: RISKS, likelihood: RISKS, owner: RISKS, mitigation: RISKS, acceptance: ['Requirement', 'Feature'], benefit: ['Feature'],
  group: STAKEHOLDER, interest: STAKEHOLDER, influence: STAKEHOLDER, contact: STAKEHOLDER, stages: JOURNEY, touchpoints: JOURNEY, painPoints: JOURNEY,
  actor: USE_CASE, trigger: USE_CASE, preconditions: USE_CASE, steps: USE_CASE, exceptions: USE_CASE, postconditions: USE_CASE,
};

/** Чи стосується поле запису аналізу виду `kind` (прототип v4 baApplies). Чиста функція. */
export function appliesToKind(field: string, kind: string): boolean {
  const kinds = KIND_FIELDS[field];
  return !kinds || kinds.includes(kind);
}
